import * as React from 'react';
import Login from '../containers/Login';

export default () => (
  <Login />
)